import GlobalContext from '../bootstrap';
import initImagePopups from '../editor-content/img-popout';
import initPageFeedbackButtons from '../feedback/thumbs';
import initInputEnablers from '../forms/input-enabler';
import initInformationSearch from '../infosearch';
import initLazyLoadedStyles from '../lazyloading/styles';
import initPrintable from '../print';
import initPropertySliders from '../property/sliders';
import initScrollToTop from '../scrolltotop';
import initTextToSpeachButtons from '../texttospeach';
import initTypeaheads from '../typeahead';

class InformationArticlePage extends GlobalContext {
    constructor() {
        super();
        this._initialiseComponents();
    }

    _initialiseComponents(): void {
        initLazyLoadedStyles();

        initPageFeedbackButtons();

        initImagePopups();

        initTypeaheads();

        initTextToSpeachButtons();

        initInformationSearch();

        initScrollToTop();

        initPrintable();

        initPropertySliders();

        initInputEnablers();
    }
}

if ( !window.articlePage ) {
    window.articlePage = new InformationArticlePage();
}
